import { AxiosResponse } from 'axios'

import ClientSDK from '../../App/ClientSDK'

import { IApiProduct, IProduct } from './IProduct'
import { IApiProductBrand, IProductBrand } from './IProductBrand'
import Transformer from './Transformer'

class ProductDataStore {
    static brandId: number | null

    static getProducts(
        offset: number,
        limit: number,
        sorting: any
    ): Promise<{ data: IProduct[]; count: number }> {
        const params = new URLSearchParams()
        if (offset) params.append('page[offset]', String(offset))
        if (limit) params.append('page[limit]', String(limit))
        if (sorting) {
            for (const field in sorting) {
                if (!sorting.hasOwnProperty(field)) continue

                params.append(
                    `order_by[${field}]`,
                    sorting[field] === 'DESC' ? 'desc' : 'asc'
                )
            }
        }

        if (ProductDataStore.brandId) {
            params.append('brand', String(ProductDataStore.brandId))
        }

        const url = `products?${params.toString()}`

        return ClientSDK.instance()
            .get(url)
            .then((response: AxiosResponse): {
                data: IProduct[]
                count: number
            } => {
                return {
                    data: response.data.list.map((data: IApiProduct) =>
                        Transformer.transformProduct(data)
                    ),
                    count: response.data.pagination.total,
                }
            })
    }

    static patchProduct(product: IProduct, field: string, newValue: any) {
        const url = `product/${product.id}`
        const intFields = ['inStock', 'minStock', 'maxStock']

        if (intFields.includes(field)) {
            newValue = parseInt(newValue)
        }

        field = field.replace(/[A-Z]/g, (letter) => `_${letter.toLowerCase()}`)

        const data: any = {}
        data[field] = newValue

        return ClientSDK.instance().patch(url, data)
    }

    static getProductBrands(): Promise<IProductBrand[]> {
        const url = 'product/brand'

        return ClientSDK.instance()
            .get(url)
            .then((response: AxiosResponse): IProductBrand[] => {
                return response.data.list.map((data: IApiProductBrand) =>
                    Transformer.transformProductBrand(data)
                )
            })
    }

    static setBrandId(brandId: number | null) {
        ProductDataStore.brandId = brandId
    }
}

export default ProductDataStore
